import { render, staticRenderFns } from "./AlertSuggestions.vue?vue&type=template&id=37f77ef5&scoped=true&"
import script from "./AlertSuggestions.vue?vue&type=script&lang=js&"
export * from "./AlertSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./AlertSuggestions.vue?vue&type=style&index=0&id=37f77ef5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f77ef5",
  null
  
)

export default component.exports